import { Text, TextProps } from '@chakra-ui/react';

// Inline Typogaphy Helpers
export const B = (props: Omit<TextProps, 'fontWeight' | 'as'>) => (
   <Text {...props} as="span" fontWeight="bold" />
);
export const I = (props: Omit<TextProps, 'textDecoration' | 'as'>) => (
   <Text {...props} as="span" textDecoration="italic" />
);
export const U = (props: Omit<TextProps, 'textDecoration' | 'as'>) => (
   <Text {...props} as="span" textDecoration="underline" />
);
